import styled,{css} from 'styled-components';
export const Container = styled.li`
    display: flex;
    width: 22rem;
    max-width: 22rem;
    flex-direction: column;
    justify-content: space-between; 
    margin-bottom: 0.5rem;
    padding: 0.2rem;
    border-radius: 4px;
    background-color: transparent;

    ${({isStatus})=> isStatus &&
      css`
        background-color: ${({isOnline})=> isOnline  ?'#1c8e3e66' :'#8f8f8f3d'};
      `
    }
`
export const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    flex-direction: row;
    .line{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        .name--{
            display: flex;
            height: 100%;
            width: 220px;
            max-width: 220px;
            align-items: center;
            font-weight: bolder;
            .-name{
                max-width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .status--{
            display: flex;
            flex-direction: row;
            gap: 0.5rem;
            margin-right: 0.3rem;
        }
    }
    .circle-{
        width:15px;
        height: 15px;
        border-radius: 50%;
    }
    .-on{
        background-color: #1e8e3e;
    }
    .-pause{
        background-color: #fcbc05;
    }
    .-off{
        background-color: #8f8f8f;
    }

`